"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const faqInputs = [
  {
    name: "title",
    type: "string",
    defaultValue: "Top Ploom Club FAQs",
    required: true,
  },
  {
    name: "additionalHelp",
    type: "string",
    defaultValue:
      "If you have rewards club questions to reach out to us at {#helpEmail#} and someone will be able to help you Monday to Friday 9-5 pm.",
    required: true,
  },
  {
    name: "additionalHelpEmail",
    type: "string",
    defaultValue: "ploomclub@ploom.com",
    required: true,
  },
  {
    name: "theme",
    type: "string",
    enum: ["dark-theme", "light-theme"],
    defaultValue: "light-theme",
  },
  {
    name: "details",
    type: "string",
    defaultValue: "More Club FAQ",
    required: true,
  },
  {
    name: "detailsLink",
    type: "string",
    defaultValue: "/",
    required: true,
  },
  {
    name: "faqList",
    type: "list",
    required: true,
    subFields: [
      {
        name: "faqDetails",
        type: "string",
        required: true,
      },
      {
        name: "faqTitle",
        type: "string",
        required: true,
      },
    ],
    defaultValue: [
      {
        faqDetails:
          "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat",
        faqTitle: "Ploom Club FAQ Question?",
      },
    ],
  },
] as const satisfies Inputs;

const Faq = dynamic(async () =>
  withValidation(faqInputs, (await import("./Faq")).Faq, "Faq")
);
export const FaqComponent: RegisteredComponent = {
  name: "Faq",
  component: Faq,
  inputs: faqInputs,
};
